import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";

@Component({
  selector: 'operations-menu',
  templateUrl: './operations-menu.component.html',
  styleUrls: ['./operations-menu.component.scss'],
  imports: [MatIconModule, MatButtonModule, MatMenuModule, MatDividerModule, NgClass]
})
export class OperationsMenuComponent {

  @Input() operations: {
    icon: string;
    name: string;
    requireRole?: string;
    isDelete?: boolean;
    danger?: boolean;
    showIn?: string[];
    onClick?: () => void;
    hidden?: () => boolean;
  }[] = [];
  @Input() id: string;

  @Output() operationClick = new EventEmitter<string>();

  protected handleClick(operationName: string) {
    this.operationClick.emit(operationName);
  }

  protected get singleActions() {
    return this.operations
      .filter(operation => operation.showIn?.includes('single'))
      .filter(operation => !(operation.hidden && operation.hidden()));
  }

}